module.exports = __webpack_public_path__ + "static/energy_private_10-0538cf58e54fbc6e14c36f8f185cfd9f.jpg";